import React, { useMemo } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';

export const OutstandingApplicationDrawHistoryGrid = ({ loan }) => {
    const dataGridRef = useMemo(() => React.createRef<DataGrid>(), []);

    const onDrawNumberHeaderCellRender = (e) => {
        if (e.rowType !== 'header') {
            return null;
        }
        return (
            <>
                <span style={{ color: '#2c5591', fontWeight: 'bold' }}>Draw Number</span>
            </>
        );
    };

    const onFundedRender = (e) => {
        let value = e.data.fundedOn;

        if (e.data.isOutOfBalance) {
            value += ' (out of balance)';
        }

        return value;
    };

    const onCellPrepared = (e) => {
        const width = dataGridRef.current?.instance.element().offsetWidth;

        if (width && width < 450 && e.rowType === 'header') {
            e.cellElement.style.display = 'none';
        }

        e.column.caption && e.cellElement.setAttribute('data-column', e.column.caption);
    };

    return (
        <DataGrid
            ref={dataGridRef}
            keyExpr='drawNumber'
            id='outstandingApplicationsTable'
            dataSource={loan?.drawHistoryLines}
            showBorders={true}
            showRowLines={true}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnResizing={true}
            allowColumnReordering={false}
            columnResizingMode={'widget'}
            columnMinWidth={20}
            cellHintEnabled={true}
            onCellPrepared={onCellPrepared}
            width={'auto'}
        >
            <Column
                cssClass='label'
                calculateCellValue={(cellData) => cellData.drawNumber + 1}
                alignment={'center'}
                caption='Draw Number'
                headerCellRender={onDrawNumberHeaderCellRender}
            />
            <Column
                cssClass='label'
                dataField='amountFunded'
                caption='Amount'
                format={'currency'}
            />
            <Column
                cssClass='label'
                dataField='borrowerRequested'
                alignment={'center'}
                caption='Requested'
            />
            <Column
                cssClass='label'
                dataField='fundedOn'
                alignment={'center'}
                caption='Funded'
                cellRender={onFundedRender}
            />
        </DataGrid>
    );
};

export default OutstandingApplicationDrawHistoryGrid;
